module.exports = __webpack_public_path__ + "static/media/unloadedImage.2faedefc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/unloadedImage.svg
// module id = 1268
// module chunks = 0